import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteUserDeleteRequestModel, DeleteUserDeleteResponseModel } from "@/features/user/services/user-model";

export class DeleteUserApi {
  /**
   *  利用者削除API
   */
  public deleteUser = async (
    param: DeleteUserDeleteRequestModel
  ): Promise<DeleteUserDeleteResponseModel> => {
    const path = `/api/users`;

    const res = await ApiClient.instance.delete<DeleteUserDeleteResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
